import { Stack, Tooltip, Typography, useTheme } from "@mui/material";
import HelpOutlineRoundedIcon from "@mui/icons-material/HelpOutlineRounded";
import { useTenantTranslation } from "hooks/formatters";

export const SteelGradeCell = ({
  steelGrade,
  originalSteelGrade,
}: {
  steelGrade: string;
  originalSteelGrade: string | null;
}) => {
  const theme = useTheme();
  const { t } = useTenantTranslation();
  if (originalSteelGrade === null || originalSteelGrade === steelGrade) {
    return <Typography>{steelGrade}</Typography>;
  }

  return (
    <Stack direction="row" gap={0.5} alignItems="center">
      <Typography color={theme.palette.error.dark}>{steelGrade}</Typography>
      <Tooltip
        title={`${t(
          "changedSteelGrade"
        )}: ${originalSteelGrade} → ${steelGrade}`}
      >
        <HelpOutlineRoundedIcon sx={{ fontSize: 15 }} />
      </Tooltip>
    </Stack>
  );
};
